import { jsonInstance } from './Api';

class AdminDashboardService {
 getCallTrackerData(data) {
    return jsonInstance.post(`/tracker/dashboard`,data);
  } 
  getBatches(data) {
    return jsonInstance.post(`/tracker/batches`,data);
  }
}

export default new AdminDashboardService();